<script>
import NewsletterField from '@phoenix/mixins/components/form/fields/NewsletterField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [NewsletterField],

  props: {
    useStayInTouchAsLabel: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    stayInTouch() {
      return this.$t('Form.stayInTouch', {
        privacyLink: `<a target="_blank" class="link link--text" href="${this.privacyLink}">${this.$t(
          'Form.privacy',
        )}</a>`,
      });
    },

    customAttrs() {
      return this.useStayInTouchAsLabel ? { ...this.field, label: this.stayInTouch } : this.field;
    },
  },
};
</script>

<template>
  <div>
    <checkbox-field ref="fieldRef" v-model="value" :should-validate="false" :attrs="customAttrs" />

    <p v-if="shouldDisplayStayInTouch" class="mt-4" v-html="stayInTouch" />
  </div>
</template>
